export function formatWzId(wzId: string): string {
  const noWz08 = wzId.replace('WZ08-', '');
  if (noWz08.length == 4) return noWz08.replace(/(\d{2})(\d{2})/, '$1.$2');
  if (noWz08.length == 5 && noWz08.endsWith('0')) return noWz08.replace(/(\d{2})(\d{2})(\d{1})/, '$1.$2');
  if (noWz08.length == 5) return noWz08.replace(/(\d{2})(\d{2})(\d{1})/, '$1.$2.$3');
  return noWz08.replace(/(\d{2})(\d{2})(\d{2})/, '$1.$2.$3');
}
